<aside class="primary-nav-container d-flex flex-column" [class.collapsed]="!navigationService.isExpanded()">
  <!-- Header & Logo Section -->
  <a routerLink="" class="primary-nav-header mx-auto d-flex align-items-center gap-1 text-decoration-none">
    <img src="assets/icons/avyna/icon.svg" [alt]="'app.shared.logo_alt' | translate" class="icon" />

    <img src="assets/icons/avyna/logo-no-icone.svg" alt="" class="logo"
      [class.visible]="navigationService.isExpanded()" />
  </a>

  <!-- Navigation Section -->
  <nav class="primary-nav-nav flex-grow-1 position-relative mt-4">
    <div class="active-indicator me-2" [style.transform]="'translateY(' + activeIndex() * itemHeight + 'px)'"></div>

    <ul class="list-unstyled m-0 p-0">
      @for (item of navigationService.navItems(); track item.route; let i = $index) {
      <li class="nav-item-container me-0 pe-0">
        <a [routerLink]="item.route" routerLinkActive="active" (isActiveChange)="onActiveChange($event, i, item)"
          class="nav-link ms-auto d-flex align-items-center"
          [matTooltip]="'app.navigation.primary_nav.label.' + item.label | translate"
          [matTooltipDisabled]="navigationService.isExpanded()" matTooltipPosition="right">
          <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>

          <span [class]="'text-truncate ms-3' + (navigationService.isExpanded() ? '' : ' d-none')">{{
            'app.navigation.primary_nav.label.' + item.label | translate }}</span>
        </a>
      </li>
      }
    </ul>
  </nav>

  <!-- Footer Section -->
  <div class="primary-nav-footer py-3 d-flex justify-content-center align-items-center mt-auto">
    <app-theme-toggle></app-theme-toggle>
  </div>

  <div class="version">
    @if (navigationService.isExpanded()) {
    <p class="version-text mt-auto ps-1 mb-1">Avyna v{{ version }}</p>
    } @else {
    <p class="version-text mt-auto ps-1 mb-1">v{{ version }}</p>
    }
  </div>
</aside>